export const StatusDot = ({
  integration,
  connected,
  oauth_completed,
}: {
  integration: 'google' | 'jira';
  connected?: boolean;
  oauth_completed?: boolean;
}) => (
  <span
    className="relative inline-flex items-center justify-center w-5 h-5"
    title={
      integration === 'google'
        ? connected && oauth_completed
          ? 'Подключено и авторизовано'
          : connected && !oauth_completed
            ? 'Подключено, но не авторизовано'
            : 'Не подключено'
        : connected
          ? 'Подключено'
          : 'Не подключено'
    }
  >
    {/* Внешний круг */}
    <span
      className={`absolute w-full h-full rounded-full ${
        integration === 'google' && connected && !oauth_completed
          ? 'bg-orange-500/20'
          : connected
            ? 'bg-green-500/20'
            : 'bg-red-500/20'
      }`}
    />
    {/* Внутренняя "лампа" */}
    <span
      className={`relative w-3 h-3 rounded-full ${
        integration === 'google'
          ? connected && oauth_completed
            ? 'bg-green-400 shadow-[0_0_15px_4px_rgba(74,222,128,0.7)] animate-[pulse_2s_infinite]'
            : connected && !oauth_completed
              ? 'bg-orange-400 shadow-[0_0_10px_3px_rgba(251,146,60,0.7)] animate-[pulse_2s_infinite]' // Оранжевая пульсация
              : 'bg-red-400 shadow-[0_0_10px_2px_rgba(248,113,113,0.5)]'
          : connected
            ? 'bg-green-400 shadow-[0_0_15px_4px_rgba(74,222,128,0.7)] animate-[pulse_2s_infinite]'
            : 'bg-red-400 shadow-[0_0_10px_2px_rgba(248,113,113,0.5)]'
      }`}
    />
    {/* Блеск */}
    <span className="absolute top-1 left-1 w-1 h-1 rounded-full bg-white/60" />
  </span>
);
